/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import { toUpper } from "lodash";
import React from "react";
import { Login } from "../../../core/authentication";
import {
  createAnonymousSession,
  getLanguage,
  removeHybrisSession,
} from "../../../services/commerceServices/accessToken";
import { qualtricsconfig } from "../../qualtrics/qualtrics";

interface FooterState {
  currentLanguage: string;
}
/**
 * Reusable React component - Footer.
 *
 * @namespace Footer
 */
class Footer extends React.Component<any, FooterState> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentLanguage: "",
    };
  }
  componentDidMount = () => {
    //qualtrics call
    // createAnonymousSession()
    if (process.env.REACT_APP_ENVIRONMENT === "prod") {
      qualtricsconfig();
      const container: any = document.createElement("div");
      container.id = "ZN_4YhsmY5zTJaBGKO";
      document.body.appendChild(container);
    } else {
      qualtricsconfig();
      const container: any = document.createElement("div");
      container.id = "ZN_4YhsmY5zTJaBGKO";
      document.body.appendChild(container);
    }
  };

  componentWillReceiveProps = (props: any) => {
    let currentTime = Math.round(new Date().getTime() / 1000);
    let sessionExpiryTime = parseInt(
      localStorage.getItem("sessionExpiryTime") || ""
    );

    if (
      (props && props.i18n.language !== this.state.currentLanguage) ||
      (sessionExpiryTime && currentTime >= sessionExpiryTime)
    ) {
      this.setState(
        {
          currentLanguage:
            sessionStorage.getItem("languageTypeOfApp") || "en-us",
        },
        async () => {
          await createAnonymousSession().then(async (res: any) => {
            let value: any =
              currentTime +
              parseInt(res && res.securityToken && res.securityToken.expiresIn);
            localStorage.setItem("sessionExpiryTime", value);

            if (res !== undefined && !localStorage.getItem("logout")) {
              if (
                !localStorage.getItem("okta-token-storage") &&
                res?.securityAccount?.userType.toUpperCase() !== "ANONYMOUS"
              ) {
                localStorage.setItem(
                  "previousPath",
                  this.props.history?.location?.pathname
                );
                await Login(this.props.oktaAuth);
              }
            }
          });
        }
      );
    }
  };
  render() {
    const language = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    return (
      <footer
        tabIndex={-1}
        role="contentinfo"
        aria-hidden="false"
        aria-label="Footer"
        className="footer-area"
      >
        <div className="instruction">
          {this.props.t("common.footer_statement")}
        </div>
        <div className="copyrights-area">
          <span className="copyright">
            {this.props.t("common.footer_copyright")}
          </span>
          <span className="tags">
            <span
              tabIndex={0}
              role="link"
              className="link"
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_PRIVACY_NOTICE}`?.replaceAll(
                    "language",
                    getLanguage() || ""
                  ),
                  "_blank"
                );
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  window.open(
                    `${process.env.REACT_APP_PRIVACY_NOTICE}`?.replaceAll(
                      "language",
                      getLanguage() || ""
                    ),
                    "_blank"
                  );
                }
              }}
            >
              {this.props.t("common.footer_privacy_notice")}
            </span>{" "}
            |{" "}
            <span
              tabIndex={0}
              role="link"
              className="link"
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_POLICY_SECURITY}`?.replaceAll(
                    "language",
                    getLanguage() || ""
                  ),
                  "_blank"
                );
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  window.open(
                    `${process.env.REACT_APP_POLICY_SECURITY}`?.replaceAll(
                      "language",
                      getLanguage() || ""
                    ),
                    "_blank"
                  );
                }
              }}
            >
              {this.props.t("common.footer_policy_security")}
            </span>{" "}
            |{" "}
            <span
              tabIndex={0}
              role="link"
              className="link"
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_TERMS_OF_USE}`?.replaceAll(
                    "language",
                    getLanguage() || ""
                  ),
                  "_blank"
                );
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  window.open(
                    `${process.env.REACT_APP_TERMS_OF_USE}`?.replaceAll(
                      "language",
                      getLanguage() || ""
                    ),
                    "_blank"
                  );
                }
              }}
            >
              {this.props.t("common.footer_terms_of_use")}
            </span>
          </span>
        </div>
      </footer>
    );
  }
}

export default Footer;
